import makeStyles from '@mui/styles/makeStyles'
import { Paper, Theme, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { IGameCharacter } from '../../../../../../../api/types/character'
import React from 'react'
import { UserCharBadge } from '../UserCharBadge/UserCharBadge'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { mutationLeaveGame } from '../../../../../../../api/mutations'
import { gameCharsQueryKey } from '../../../../../../../api/queries'
import { useGlobalError } from '../../../../../../../context/GlobalError'
import { ConfirmationDialog } from '../../../../../../../components/ConfirmationDialog/ConfirmationDialog'
import { extractMessage } from '../../../../../../../utils'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
      padding: theme.spacing(1),
    },
    badges: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
  })
)

interface UserCharBadgeListProps {
  game_chars: IGameCharacter[]
  onCharSelect: (selected: IGameCharacter) => void
  selected?: IGameCharacter
}

export const UserCharBadgeList: React.FC<UserCharBadgeListProps> = ({
  game_chars,
  onCharSelect,
  selected,
}) => {
  const classes = useStyles()
  const { addError } = useGlobalError()
  const queryClient = useQueryClient()
  const { mutate: leaveGame } = useMutation(
    (char_id: number) => mutationLeaveGame(char_id, game_chars[0].game_id),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się usunąć postaci z gry', err?.status)
      },
      onSuccess: async () => {
        queryClient.invalidateQueries(gameCharsQueryKey(game_chars[0].game_id))
      },
    }
  )

  return (
    <Paper className={classes.paper}>
      <Typography color="text.secondary" variant="caption" display="block" gutterBottom>
        Gracze
      </Typography>
      <div className={classes.badges}>
        {(!game_chars || game_chars.length === 0) && 'Brak graczy'}
        {game_chars.map(c => (
          <ConfirmationDialog
            key={c.character.id}
            body={<div>{`Usunąć gracza ${c.character.name} z gry?`}</div>}
          >
            {(confirm: any) => (
              <UserCharBadge
                isSelected={selected === c}
                game_char={c}
                handleDelete={confirm(
                  (e: any) => () =>
                    new Promise(r => {
                      leaveGame(c.character.id)
                      r('ok')
                    })
                )}
                handleClick={() => onCharSelect(c)}
              />
            )}
          </ConfirmationDialog>
        ))}
      </div>
    </Paper>
  )
}
